import React from 'react';
import {checkLockStatus, getCompetitorImages, isImageNotAvailable} from "../compare.method";
import CloseIcon from "@mui/icons-material/Close";
import {Color} from "../Color";
import {Change} from "../Change";
import LockCompetitor from "../../Button/LockCompetitor";
import {currencyConverter} from "../../../utility/methods";
import {faUpDownLeftRight} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useMediaQuery} from "react-responsive";
import {faExchange} from "@fortawesome/free-solid-svg-icons/faExchange";

const SecondaryCompetitors = ({
                                  vehicle,
                                  index,
                                  openModal,
                                  setOpenModal,
                                  secondaryYear,
                                  vehiclesMakes,
                                  vehicleModel,
                                  trimModel,
                                  setTrimModel,
                                  setVehicleModel,
                                  setVehicleMake,
                                  vehiclesTrim,
                                  vehicleIndex,
                                  vehicleTypeName,
                                  driveType,
                                  setDriveType,
                                  isLocked,
                                  handleReload,
                                  removeVehicle,
                                  activeLocale,
                                  headerLoadType,
                                  t,
                                  changeHandler,
                                  trimCodes,
                                  handleToggle,
                                  handleModalClose,
                                  vehicleData,
                                  setVehicleData,
                                  hideImages,
                                  hideButtons
                              }) => {
    const {code, year, make, model, trim} = vehicle ?? {};
    const isMinWidth = useMediaQuery({ query: '(min-width: 899px)' });
    const isMaxHeight = useMediaQuery({ query: '(max-height: 769px)' });
    const vehicleCTA = "https://www.jdpower.com/cars-for-sale/make-"+ make.toLowerCase() + "/model-" + model.toLowerCase().replace(/ /g, "-")

    return (
        <div key={code}>
            {vehicle ? (
                <>
                    <div className={`competitor-vehicle-overview${hideImages ? ' images-hidden' : ''}`}>
                        <div className={"action-buttons"}>
                            <button type="button"
                                    className={`move-icon${hideButtons ? ' buttons-hidden' : ''}`}>
                                <FontAwesomeIcon icon={faUpDownLeftRight}/>
                            </button>
                            <button
                                type="button"
                                className={`close-compare${hideButtons ? ' buttons-hidden' : ''}`}
                                id="features-vehicle-remove"
                                onClick={() => removeVehicle(vehicle, index)}
                                disabled={isLocked && checkLockStatus(vehicle, isLocked, index)}
                            >
                                <CloseIcon fontSize="medium"/>
                            </button>
                            </div>
                        {getCompetitorImages(vehicle, activeLocale)}
                        <div
                            className="vehicle-detail"
                            style={vehicle?.media == null ? { top: '-25px' } : isImageNotAvailable(vehicle) ? { top: '-14px' } : {}}
                        >
                            <div className="competitor-vehicle-yearMake">
                                {year} {make}
                            </div>
                            <div className="competitor-vehicle-yearMake">
                                {model} {trim}
                            </div>
                            <div className="price-start">
                                {vehicle && <span>{t('overview.startingFrom')} </span>}
                                {vehicle && currencyConverter(vehicle?.pricing.msrp, activeLocale)}
                                {vehicle && <span>*</span>}
                            </div>
                            {headerLoadType != null && (!isMaxHeight || !isMinWidth) && vehicle && (
                                <div className={"vehicle-CTA"}>
                                    <a target="_blank" href={vehicleCTA}>See Cars For Sale</a>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={`secondary-feature-controller${hideButtons ? ' buttons-hidden' : ''}`}>
                        <div
                            className={"color-box-controller"}
                            style={{left: '-10px'}}
                        >
                            <Color
                                primaryColor={vehicle?.colors?.exteriors}
                                translate={t}
                                id={index}
                                mediaColor={vehicle?.currentColor}
                                interiorColor={vehicle?.colors?.interiors}
                            />
                        </div>
                        {isMaxHeight && isMinWidth ?
                            <div className={"btn-change-icon-wrapper"}>
                                <FontAwesomeIcon icon={faExchange}
                                                 className={checkLockStatus(vehicle, isLocked, index) ? "btn-change-icon btn-change-icon-disabled" : 'btn-change-icon'}
                                                 data-testid="change-button"
                                                 onClick={(event) => changeHandler(event.target.id, vehicle)}
                                                 id={index}
                                />
                                <div className="tooltip-change" style={{ width: activeLocale === 'fr-CA' ? '80px' : '' }}>
                                    {vehicle ? t('overview.changeSelectModal.change') : t('overview.controls.selectVehicle')}
                                </div>
                            </div>: null
                        }
                        <div className="secondaryvehicleController">
                            <div className="change-modal">
                                    {!isMaxHeight || !isMinWidth ?
                                        <button
                                            id={index}
                                            className={checkLockStatus(vehicle, isLocked, index) ? `btn-default ${headerLoadType ? "jdpa-button-disabled" : "btn-change-disabled"}` : "btn-default btn-change-compare"}
                                            value={vehicle}
                                            onClick={(event) => changeHandler(event.target.id, vehicle)}
                                            disabled={Object.keys(isLocked).length > 0 && checkLockStatus(vehicle, isLocked, index)}
                                            title={checkLockStatus(vehicle, isLocked, index) ? t("overview.changeSelectModal.vehicleLocked") : null}
                                        >
                                            {vehicle ? t('overview.changeSelectModal.change') : t('overview.controls.selectVehicle')}
                                        </button>: null
                                    }

                                <Change
                                    vehicleData={vehicleData}
                                    setVehicleData={setVehicleData}
                                    openModal={openModal}
                                    setOpenModal={setOpenModal}
                                    handleModalClose={handleModalClose}
                                    years={secondaryYear}
                                    vehicleMake={vehiclesMakes}
                                    vehicleModels={vehicleModel}
                                    trimModel={trimModel}
                                    setTrimModel={setTrimModel}
                                    setVehicleModel={setVehicleModel}
                                    setVehicleMake={setVehicleMake}
                                    vehiclesTrim={vehiclesTrim}
                                    vehicleIndex={vehicleIndex}
                                    vehicleTypeName={vehicleTypeName}
                                    driveType={driveType}
                                    setDriveType={setDriveType}
                                    lockedVehicle={isLocked}
                                    onReload={handleReload}
                                />
                            </div>
                            <LockCompetitor
                                isLocked={isLocked}
                                vehicle={vehicle}
                                vehicleIndex={index}
                                trimCodes={trimCodes}
                                toggleLock={() => handleToggle(index, vehicle)}
                            />
                        </div>

                    </div>
                    {headerLoadType != null && isMaxHeight && isMinWidth && (
                        <div className={"vehicle-CTA"}>
                            <a target="_blank" href={vehicleCTA}>See Cars For Sale</a>
                        </div>
                    )}
                </>
            ) : (
                <div className="no-vehicle">{t('overview.noVehicleSelected')}</div>
            )}
        </div>
    );
};

export default SecondaryCompetitors;